import React from "react";
import { CreateGameDialog } from "./CreateGameDialog";
import { RegisterDialog } from "./RegisterDialog";
import { AlertDialog } from "./AlertDialog";
import { WithdrawConfirmationDialog } from "./WithdrawConfirmationDialog";
import { ConnectWalletDialog } from "./ConnectWalletDialog";
import { MetamaskNotInstalledDialog } from "./MetamaskNotInstalledDialog";
import { WrongNetwork } from "./WrongNetwork";
import {GetFaucet} from "./GetFaucet";

export const DialogsContainer = () => {
  return (
    <>
      <CreateGameDialog />
      <WrongNetwork />
      <RegisterDialog />
      <WithdrawConfirmationDialog />
      <ConnectWalletDialog />
      <MetamaskNotInstalledDialog />
      <AlertDialog />
      <GetFaucet />
    </>
  );
};
